import { Hidden, useMediaQuery, useTheme } from '@material-ui/core'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import BackGroundMobile from '../../assets/images/BackGroundMobile.png'
import BackGroundTablet from '../../assets/images/BackGroundTablet.png'
import BedBankLogo from '../../assets/images/BedBankLogo.svg'
import BedBankLogoMobile from '../../assets/images/BedBankLogoMobile.svg'
import BedBankLogoTablet from '../../assets/images/BedBankLogoTablet.svg'
import adoTelBtn from '../../assets/images/adoTelBtn.svg'
import adotelMap from '../../assets/images/adotelMap.svg'
import adotelMapMobile from '../../assets/images/adotelMapMobile.svg'
import adotelMapTablet from '../../assets/images/adotelMapTablet.svg'
import Background from '../../assets/images/backGround.png'
import { addDaysToDate, getTodayDate } from '../../helpers/date'
import { getDefaultCurrency } from '../../helpers/userData'
import { SearchAvailabilityInput } from '../../types/searchAvailability'
import SearchWidgetMain from './SearchWidgets/SearchWidgetMain'
import useStyles from './styles/index.styles'

const Booking = () => {
  const classes = useStyles()
  const theme = useTheme()
  const params = useParams<{ channelId: string; code: string; name: string }>()
  const isXsDown = useMediaQuery(theme.breakpoints.down('xs'))
  const isTablet = useMediaQuery(theme.breakpoints.down('sm'))
  const [readMode, setreadMode] = useState(false)
  const [searchAvailabilityInput, setSearchAvailabilityInput] =
    useState<SearchAvailabilityInput>({
      channelId: '',
      arrival: getTodayDate(),
      departure: addDaysToDate(getTodayDate(), 1),
      currency: getDefaultCurrency(),
      guestsAges: [24],
      sort: 'PRICE_ASC',
      showUnavailableRatePlans: true
    })

  useEffect(() => {
    setSearchAvailabilityInput((prev) => ({
      ...prev,
      channelId: params.channelId
    }))
  }, [params])

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <div className={classes.coverImageContainer}>
          <img
            src={
              isXsDown
                ? BackGroundMobile
                : isTablet
                ? BackGroundTablet
                : Background
            }
            alt="bedbank"
            className={classes.coverImage}
          />
          <div className={classes.coverDetails}>
            <img
              src={
                isXsDown
                  ? BedBankLogoMobile
                  : isTablet
                  ? BedBankLogoTablet
                  : BedBankLogo
              }
              alt="adobed"
              className={classes.logo}
            />
            <Hidden xsUp>
              <a
                href="https://adotel.net"
                target="_blank"
                rel="noopener noreferrer">
                <img src={adoTelBtn} alt="adotel" className={classes.link} />
              </a>
            </Hidden>
          </div>
        </div>
        <div className={classes.searchWidgetContainer}>
          <SearchWidgetMain
            setSearchAvailabilityInput={setSearchAvailabilityInput}
            searchAvailabilityInput={searchAvailabilityInput}
            readMode={readMode}
            setreadMode={setreadMode}
          />
          <div className={classes.mainImageContainer}>
            <img
              src={
                isXsDown
                  ? adotelMapMobile
                  : isTablet
                  ? adotelMapTablet
                  : adotelMap
              }
              alt="hotel"
              className={classes.mainCoverImage}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
export default Booking
